import { html } from "lit";
import { getDummyText, renderStandardPictureElement } from "../../../utils";

const HeroSuccessStoriesSlideTemplate = ({
    headline,
    copy,
    linkText,
    textRight,
}: {
    headline: string;
    copy: string;
    linkText: string;
    textRight: boolean;
}) => html`
    <div
        class="ux-block-hero ux-iws-hero-success-story ux-iws-hero-success-story--${textRight
            ? "right"
            : "left"}"
    >
        <div class="ux-block-hero__image">
            ${renderStandardPictureElement({
                width: 1024,
                height: 482,
            })}
        </div>
        <div class="ux-block-hero__background"></div>
        <div class="ux-block-hero__content">
            <ux-icon name="quotation-mark"></ux-icon>
            <div class="ux-u-mb-fluid-xxxs">
                <h2 class="ux-text-headline ux-text-headline--big">
                    ${headline}
                </h2>
            </div>
            <div class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase">
                <strong>${copy}</strong>
            </div>
            <div class="ux-u-margin-top-20">
                <a class="ux-button ux-button--green" href="#">${linkText}</a>
            </div>
        </div>
    </div>
`;

const renderSuccessStoriesHeroSlides = (numSlides: number = 1) => {
    return Array(numSlides)
        .fill("")
        .map(
            (_, index) => html`
                <ux-slider-slide label="Success Story ${index + 1}">
                    ${HeroSuccessStoriesSlideTemplate({
                        headline: `Success Story ${
                            index + 1
                        } Headline Lorem ipsum dolor sit amet`,
                        copy: getDummyText(20 + index * 10),
                        linkText: "Read Story",
                        textRight: index % 2 === 0,
                    })}
                </ux-slider-slide>
            `
        );
};

export const SuccessStoriesHeroSliderTemplate = () => html`
    <ux-slider
        autoplay
        arrows-follow-img
        effect="slide"
        class="ux-iws-hero-success-stories-slider"
        slides-auto-height
    >
        ${renderSuccessStoriesHeroSlides(4)}
        <ux-slider-pagination
            slot="pagination"
            bottom-pagination
            label
            progress
            without-arrows
        ></ux-slider-pagination>
    </ux-slider>
`;
